import React from "react";
import {Col, DatePicker, Form, Input, Row, Select} from "antd";
import {Rule} from 'rc-field-form/lib/interface';

type CommonField = "requestProtocolNumber" | "requestProtocolDate" | "email";

interface Props {
    fieldsToShow: CommonField[];
    disableFields?: boolean;
}

const emailTransmissionOptions = [
    {value: 'email', label: 'Email'},
    {value: 'pec', label: 'PEC'},
    {value: 'altro', label: 'Altro'},
];

const getEmailRules = (transmissionType: string): Rule[] => {
    const rules: Rule[] = [{required: true, message: "Questo campo è obbligatorio!"}];
    if (transmissionType === 'email' || transmissionType === 'pec')
        rules.push({type: 'email', message: "Inserisci un indirizzo email valido!"});
    return rules;
};

const getInputLabel = (transmissionType: string) => {
    switch (transmissionType) {
        case 'email':
            return 'Indirizzo email';
        case 'pec':
            return 'Indirizzo PEC';
        case 'altro':
            return 'Altro';
    }
};

export default function CommonFormFields({fieldsToShow, disableFields = false}: Props) {
    return (
        <>
            <Row gutter={8}>
                <Col span={8}>
                    {fieldsToShow.includes("requestProtocolNumber") && (
                        <Form.Item
                            label="Numero protocollo richiesta"
                            name="requestProtocolNumber"
                            rules={[{required: true, message: "Inserisci un numero di protocollo!"}]}
                        >
                            <Input disabled={disableFields}/>
                        </Form.Item>
                    )}</Col>
                <Col span={10}>
                    {fieldsToShow.includes("requestProtocolDate") && (
                        <Form.Item
                            label="Data protocollazione richiesta"
                            name="requestProtocolDate"
                            rules={[{required: true, message: "Inserisci la data della protocollazione!"}]}
                        >
                            <DatePicker style={{width: 200}} format={"DD-MM-YYYY"} disabled={disableFields}/>
                        </Form.Item>
                    )}
                </Col>
            </Row>

            {fieldsToShow.includes("email") && (
                <>
                    <Row gutter={8}>
                        <Col span={8}>
                            <Form.Item
                                label="Trasmessa via"
                                name="transmissionType"
                                rules={[{required: true, message: "Seleziona una modalità di trasmissione!"}]}
                                initialValue="email"
                            >
                                <Select
                                    options={emailTransmissionOptions}
                                    disabled={disableFields}
                                    placeholder="Seleziona la modalità"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                shouldUpdate={(prevValues, currentValues) =>
                                    prevValues.transmissionType !== currentValues.transmissionType
                                }
                            >
                                {({getFieldValue}) => {
                                    const currentTransmissionType = getFieldValue('transmissionType') || 'email';
                                    const inputLabel = getInputLabel(currentTransmissionType);

                                    return (
                                        <Form.Item
                                            style={{width:250}}
                                            label={inputLabel}
                                            name="email"
                                            rules={getEmailRules(currentTransmissionType)}
                                        >
                                            <Input disabled={disableFields}/>
                                        </Form.Item>
                                    );
                                }}
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
}
